import { $api } from '../y/api';
import { getCountry } from './me';

interface OTPStartResponse {
    challenge: string;
    phone: string;
    recaptcha_ok: boolean;
    recaptcha_score: number;
}

export function otpStartPhone(phone: string, recaptcha: string) {
    return $api.POST<OTPStartResponse>('otp/start', { phone, recaptcha, default_country: getCountry() });
}

export function otpStartEmail(email: string) {
    return $api.POST<OTPStartResponse>('otp/start', { email, default_country: getCountry() });
}

export function otpSend(challenge: string) {
    return $api.POST('otp/send', { challenge });
}

interface OTPVerifyResponse {
    token: string;
}

export function otpVerify(challenge: string, code: string) {
    return $api.POST<OTPVerifyResponse>('otp/verify', { challenge, code });
}
